import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'listColor',
    standalone: false
})
export class ListColorPipe implements PipeTransform {
  transform(value: any) {
    if (isNaN(Number(value))) {
      return `0`;
    }
    if (Number(value) > 0) {
      return `<div class='green'>` + Number((Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2)).toLocaleString('tr-TR') + ` %</div>`;
    } else if (Number(value) > 0) {
      `<div class='red'>` + Number((Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2)).toLocaleString('tr-TR') + ` %</div>`;
    }
    return 0;
  }
}
